export const fieldContentMargin = 'var(--plasma-field-content-margin)';
export const fieldHelperTextMarginTop = 'var(--plasma-field-helper-text-margin-top)';
export const fieldLabelMarginBottom = 'var(--plasma-field-label-margin-bottom)';

export const inputBorderRadius = 'var(--plasma-input-border-radius)';
export const inputBorderWidth = 'var(--plasma-input-border-width)';
export const inputLabelMarginTop = 'var(--plasma-input-label-margin-top)';
